import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/luxury-tented-lodging";
const TITLE = "Luxury Tented Lodging — Backland Nature Suites";
const OG_TITLE = "Backland Nature Suites";
const DESC =
  "Backland's Nature Suites: one-of-a-kind luxury tented lodging with panoramic windows, en-suite baths, and hot tub/starview options across 160 private acres.";
const OG_IMAGE =
  "https://www.travelbackland.com/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/path-hero.jpg";

export const Route = createFileRoute("/luxury-tented-lodging")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: OG_TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LodgingBusiness",
          name: "Backland — Luxury Tented Lodging",
          url: URL,
          description: DESC,
        }),
      },
    ],
  }),
  component: SuitesRoute,
});

function SuitesRoute() {
  return <StoryExperience initialCategorySlug="suites" />;
}
